import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

document.title = "Pitch.lu";

// Continuously remove the Emergent badge if it gets injected by the platform.
const stripEmergentBadge = () => {
  const el = document.getElementById("emergent-badge");
  if (el) el.remove();
};
stripEmergentBadge();
new MutationObserver(stripEmergentBadge).observe(document.documentElement, { childList: true, subtree: true });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
